import { trpc } from '@/shared/api';

interface MyOrderDetailQueryOptions {
  readonly enabled?: boolean;
}

/** 내 주문 상세(orders.getMine, 주문 설계 §8-2) — 진행·송장·지연·취소 요청·배송지·주문한 발행본·결제. */
export const useMyOrderDetailQuery = (orderId: string, options: MyOrderDetailQueryOptions = {}) =>
  trpc.orders.getMine.useQuery(
    { orderId },
    {
      enabled: options.enabled ?? true,
      // 남의 주문(NOT_OWNER)·없는 주문(ORDER_NOT_FOUND)은 재시도해도 같다.
      retry: false,
    },
  );
